import React from 'react';
import './Contact.css';
import { Button, Container, Row, Col } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import ApiKey from './ApiKey';
import Flip from 'react-reveal/Flip';

const Contact = () => {
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('gmail', ApiKey.TEMPLATE_ID, e.target,
      ApiKey.USER_ID)
      .then((result) => {
        alert("Send your message!")
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
    e.target.reset();
  }
  return (
    <>
      <Container>
        <Row className="mt-5 text-center">

          <Col md={12} xs={12}>
            <h1 className="my-3 text-center sectionTitle">Contact</h1>
            <Flip left duration={2000}>
              <div className="custom-form">
                <form onSubmit={sendEmail}>
                  <input
                    type="text"
                    name="subject"
                    className="input-contact m-2 p-2"
                    // id="subject"
                    placeholder="Subject"
                    required />
                  <br />
                  <input
                    type="email"
                    name="email"
                    className="input-contact email m-2 p-2"
                    // id="email"
                    placeholder="Your Email Address"
                    required />
                  <br />
                  <textarea
                    type="text"
                    className="m-2 p-2"
                    placeholder="Your Message"
                    name="message"
                    // id="message"
                    cols="50"
                    rows="5"
                    required>
                  </textarea>
                  <br />
                  <Button
                    size="lg"
                    type="submit"
                    className="m-2 contactBtn"
                    variant="warning">
                    Send Your Message
                  </Button>
                </form>
              </div>
            </Flip>
          </Col>

        </Row>
      </Container>
    </>
  );
};

export default Contact;